/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './prescription-spec-vital.reducer';

export const PrescriptionSpecVitalDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const prescriptionSpecVitalEntity = useAppSelector(state => state.prescriptionSpecVital.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="prescriptionSpecVitalDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.detail.title">PrescriptionSpecVital</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.id">Id</Translate>
            </span>
          </dt>
          <dd>{prescriptionSpecVitalEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.active">Active</Translate>
            </span>
          </dt>
          <dd>{prescriptionSpecVitalEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{prescriptionSpecVitalEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{prescriptionSpecVitalEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{prescriptionSpecVitalEntity.timestampEntry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{prescriptionSpecVitalEntity.cursor}</dd>
          <dt>
            <span id="observation">
              <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.observation">Observation</Translate>
            </span>
          </dt>
          <dd>{prescriptionSpecVitalEntity.observation}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{prescriptionSpecVitalEntity.comments}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.specVital">Spec Vital</Translate>
          </dt>
          <dd>{prescriptionSpecVitalEntity.specVital ? prescriptionSpecVitalEntity.specVital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.patient">Patient</Translate>
          </dt>
          <dd>{prescriptionSpecVitalEntity.patient ? prescriptionSpecVitalEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.prescription">Prescription</Translate>
          </dt>
          <dd>{prescriptionSpecVitalEntity.prescription ? prescriptionSpecVitalEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.prescriptionSpecVital.appointment">Appointment</Translate>
          </dt>
          <dd>{prescriptionSpecVitalEntity.appointment ? prescriptionSpecVitalEntity.appointment.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/prescription-spec-vital" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/prescription-spec-vital/${prescriptionSpecVitalEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PrescriptionSpecVitalDetail;
